import { Divider, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withTranslation } from "react-i18next";
import ButtonCustom from "../../components/ButtonCustom";
import CustomTypo from "../../components/CustomTypo";
import DrawerCustom from "../../components/DrawerCustom";
import { formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch } from "../../utils/util";

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(3, 4, 3, 4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
    box: {
        padding: theme.spacing(2, 2, 0, 0)
    },
    box_first: {
        paddingTop: theme.spacing(2)
    },
    box_second: {
        paddingTop: theme.spacing(1)
    },
    print_button:{
        marginTop: theme.spacing(8)
    }
});

function InvoiceDetailView(props) {

    const { t, classes, item, currency } = props;
    console.log("item invoice detail===", item)

    return (
        <DrawerCustom
            open={props.open}
            onClose={props.onClose}
            title={t('account_management')}
        >
            <Grid item xs={12}>
                <Grid item xs={12} container className={classes.boxItemContent}>
                    <Grid xs={12} item container direction='row'>
                        <Grid item xs={6}>
                            <CustomTypo mg_top_sm variant='body2' color='secondary'>
                                {item.posted_date ? formatDateToDDMMYYYYHHSSFrEpoch(item.posted_date) : ""}
                            </CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            {/* <ButtonCustom size="xs" color={item.type === 'CREDIT' ? 'green' : 'danger'}>
                                {item.type}
                            </ButtonCustom> */}
                            <CustomTypo mg_top_sm variant='subtitle2' color='secondary'>
                                {currency}{item.total ? item.total.toFixed(2) : "0.00"}
                            </CustomTypo>
                        </Grid>
                    </Grid>
                    {/* <Grid xs={12} item container alignItems='center'>
                        <Grid item xs={2} xl={1}>
                            <CustomTypo mg_top_sm variant='subtitle2' color='secondary'>
                                {currency}{item.total ? item.total.toFixed(2) : "0.00"}
                            </CustomTypo>
                        </Grid>
                        <Grid item xs={10} xl={11}>

                        </Grid>

                    </Grid> */}
                    <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_net_amount')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{item.net ? item.net.toFixed(2) : "0.00"}</CustomTypo>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_tax_amount')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{item.tax ? item.tax.toFixed(2) : "0.00"}</CustomTypo>
                        </Grid>
                    </Grid>
                    <Divider style={{ width: '100%', marginTop: 20, marginBottom: 20 }} />
                    <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_number')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{item.number}</CustomTypo>
                        </Grid>
                    </Grid>
                    {item.issued_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_issued_date')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.issued_date)}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {item.posted_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_posted_date')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.posted_date)}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {item.invoice && item.invoice.due_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_due_date')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.invoice.due_date)}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {item.invoice && item.invoice.overdue_amount > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_overdue_amount')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{item.invoice.overdue_amount ? item.invoice.overdue_amount.toFixed(2) : "0.00"}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {/* <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_total_amount')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{item.total}</CustomTypo>
                        </Grid>
                    </Grid> */}
                    {item.payment_method && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('payment_method')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{item.payment_method.type}{"-"}</CustomTypo>
                            <CustomTypo variant='body1'>{item.payment_method.identity && item.payment_method.identity.identifier ?item.payment_method.identity.identifier : null}</CustomTypo>
                        </Grid>
                    </Grid>}
                </Grid>
                {item.invoice && <Grid item xs={12}>
                    <ButtonCustom fullWidth color='primary' onClick={() => props.onPrint(item.entity_id)} className={classes.print_button} >{t('print_out')}</ButtonCustom>
                </Grid>}
            </Grid>
        </DrawerCustom>
    );
}

export default withStyles(styles)(withTranslation()(InvoiceDetailView));